function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as h } from "../../skins/skin-contract.css-mistica.js";
const c = (_param)=>{
    var { color: i , size: o = 24  } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = s(), a = i !== null && i !== void 0 ? i : t ? h.colors.inverse : h.colors.neutralHigh;
    return /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: a,
                d: "M19.435 19.407a.74.74 0 11-1.478 0 .74.74 0 011.478 0zm-.369-2.218v-4.447a.37.37 0 00-.74 0v4.447a.37.37 0 00.74 0z"
            }),
            /* @__PURE__ */ r("path", {
                fill: a,
                d: "M19.066 3.854v.018a3.702 3.702 0 01-.375 7.386 3.704 3.704 0 01-3.7-3.702 3.707 3.707 0 013.33-3.684v-.018a1.11 1.11 0 00-1.108-1.11H6.848a1.11 1.11 0 00-1.109 1.11V21.26h12.957a.37.37 0 010 .739H5V3.854C5 2.83 5.834 2 6.852 2h10.361c1.023 0 1.853.834 1.853 1.854zm-3.33 3.707a2.963 2.963 0 002.96 2.962 2.963 2.963 0 000-5.926 2.963 2.963 0 00-2.96 2.964z"
            }),
            /* @__PURE__ */ r("path", {
                fill: a,
                d: "M13.144 12.002c.55 0 1.094.147 1.573.427a.371.371 0 00.374-.64 3.904 3.904 0 00-1.943-.526 3.89 3.89 0 00-3.657 2.593h-.966a.37.37 0 000 .74h.786c-.028.18-.043.364-.043.554 0 .062.005.123.01.185h-.749a.37.37 0 000 .74h.858a3.892 3.892 0 003.77 2.962c.678 0 1.351-.18 1.943-.526a.37.37 0 00-.374-.64 3.122 3.122 0 01-1.573.427 3.158 3.158 0 01-3.008-2.223h3.193a.37.37 0 000-.74h-3.321a2.387 2.387 0 01-.01-.185c0-.19.02-.374.053-.555h3.278a.37.37 0 000-.74h-3.051a3.13 3.13 0 012.857-1.853zm5.936-2.469a.37.37 0 11-.74 0 .37.37 0 01.74 0zm-.294-4.381h-.076c-.46 0-.886.247-1.113.645a.37.37 0 00.137.507.369.369 0 00.507-.137.55.55 0 01.474-.275h.076c.194 0 .379.09.497.246.11.143.133.45.01.574l-.408.408c-.34.346-.54.82-.54 1.303a.37.37 0 00.74 0c0-.289.118-.578.321-.782l.408-.408c.422-.421.37-1.142.057-1.55a1.397 1.397 0 00-1.09-.53z"
            })
        ]
    }));
}, f = c;
export { f as default };
